
import { config } from '@fortawesome/fontawesome-svg-core';
config.autoReplaceSvg = 'nest';
//console.log(config.autoReplaceSvg)

require('@fortawesome/fontawesome');
require('@fortawesome/fontawesome-free-solid');
require('@fortawesome/fontawesome-free-regular');
require('@fortawesome/fontawesome-free-brands');